// extracted by mini-css-extract-plugin
module.exports = {"root":"_8f705a","loggedInButton":"_d58ba4","userLabel":"_46644c","menuItemLink":"_350a37"};